export default {
  namespaced: true,
  state: () => ({
    cityList: [],
    regionList: [
      /*{value: 'region name', name: 'region name'}*/
    ],
    zoneList: [
      /*{value: 'zone name', name: 'zone name', region: 'region name'}*/
    ],
    unactiveNum: 0, // 未激活用户总数
    customizedLib: null // 用户自定义输入e-CAT Lib数据
  }),
  mutations: {
    SET_CITY_LIST(state, status = null) {
      if (status == null) {
        state.cityList = []
        state.regionList = []
        state.zoneList = []
      } else {
        state.cityList = [...status]

        state.regionList = []
        state.zoneList = []
        for (let i = 0; i < state.cityList.length; i++) {
          let infoList = state.cityList[i].name.split("_")
          if (infoList && infoList.length >= 2) {
            let existIndex = state.regionList.findIndex(item => item.value == infoList[0])
            if (existIndex < 0) {
              state.regionList.push({ key: infoList[0], value: infoList[0], name: infoList[0] })
            }

            existIndex = state.zoneList.findIndex(item => item.value == infoList[1])
            if (existIndex < 0) {
              state.zoneList.push({ key: infoList[1], value: infoList[1], name: infoList[1], region: infoList[0] })
            }
          }
        }

        state.regionList.sort((item1, item2) => {
          let nameA = item1.name.toUpperCase()
          let nameB = item2.name.toUpperCase()
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })

        state.zoneList.sort((item1, item2) => {
          let nameA = item1.name.toUpperCase()
          let nameB = item2.name.toUpperCase()
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })
      }
    },

    SET_UNACTIVE_NUM(state, num) {
      state.unactiveNum = num
    },

    SET_CUSTOMIZED_LIB(state, customizedLib = null) {
      state.customizedLib = customizedLib
    }
  },
  actions: {
    storeCityList({ commit }, status) {
      commit("SET_CITY_LIST", status)
    },
    storeUnactiveNum({ commit }, num) {
      commit("SET_UNACTIVE_NUM", num)
    },
    storeCustomizedLib({ commit }, customizedLib) {
      commit("SET_CUSTOMIZED_LIB", customizedLib)
    }
  },
  getters: {
    currentCityList: state => state.cityList,
    currentRegionList: state => state.regionList,
    currentZoneList: state => state.zoneList,
    currentUnactiveNum: state => state.unactiveNum,
    currentCustomizedLib: state => state.customizedLib
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js